import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticatedSelector } from '../../data/selectors/authSelectors';

interface AuthRouteProps {
  children: ReactNode;
}
const AuthRoute = ({ children }: AuthRouteProps) => {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default AuthRoute;
